import { Flex } from 'antd';
import invariant from 'tiny-invariant';

import {
  useGraphqlApiHeaders,
  useRestApiHeaders,
} from 'business/contextProviders/useApiHeaders';
import { useAppContext } from 'business/contextProviders/useAppContext';
import { AdvancementCard } from 'business/dashboard/components/advancement-card';
import { TbmMap } from 'business/dashboard/components/map';
import { TunnelBoringMachineHeader } from 'business/dashboard/components/tunnel-boring-machine-header';
import {
  DASHBOARD_REFRESH_TIMEOUT_IN_MINUTES,
  DATA_TRANSMISSION_ONLINE_THRESHOLD,
} from 'business/dashboard/constants';
import { useDashboardTbmInfosV1ControllerGetTbmInfos } from 'generated/apiComponents';
import { Module_Enum, useGetTbmInfosQuery } from 'generated/graphql';
import { minutesToMilliseconds } from 'technical/time-utils/minutes-to-milliseconds';
import { useCurrentDate } from 'technical/time-utils/use-current-date';

import styles from './index.module.scss';

export const TunnelBoringMachineContainer = () => {
  const { currentConstructionSiteId: constructionSiteId } = useAppContext();
  invariant(constructionSiteId, 'No construction site id');

  const gqlHeaders = useGraphqlApiHeaders(Module_Enum.Dashboard);
  const restHeaders = useRestApiHeaders(Module_Enum.Dashboard);

  const { currentDate } = useCurrentDate({
    refreshTimeout: minutesToMilliseconds(DATA_TRANSMISSION_ONLINE_THRESHOLD),
  });
  const compareDate = currentDate.subtract(
    DATA_TRANSMISSION_ONLINE_THRESHOLD,
    'minute',
  );

  const tbmInfos = useGetTbmInfosQuery({
    variables: {
      constructionSiteId,
      compareDate,
    },
    context: {
      headers: gqlHeaders,
    },
    pollInterval: minutesToMilliseconds(DASHBOARD_REFRESH_TIMEOUT_IN_MINUTES),
    fetchPolicy: 'cache-and-network',
  });

  const pmData = useDashboardTbmInfosV1ControllerGetTbmInfos(
    {
      queryParams: { constructionSiteId },
      headers: restHeaders,
    },
    {
      refetchInterval: minutesToMilliseconds(
        DASHBOARD_REFRESH_TIMEOUT_IN_MINUTES,
      ),
    },
  );

  return (
    <Flex vertical gap={12} className={styles.container}>
      <TunnelBoringMachineHeader tbmInfos={tbmInfos} />
      <AdvancementCard tbmInfos={tbmInfos} pmData={pmData} />
      <TbmMap tbmInfos={tbmInfos} />
    </Flex>
  );
};
